// src/components/common/RatingInfo.tsx
import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { FlickOColors } from "../styles/color";
import { getResponsiveSize } from "../styles/globalStyles";
import { MenuItemType, RestaurantMenu } from "../types/restaurant.types";
import { formatToK } from "../utils/formatters";

interface RatingProps {
  ratings: Ratings;
}

export interface Ratings {
  avgReview: number;
  totalReview: number;
}

export const calculateRestaurantRating = (items: MenuItemType[]): Ratings => {
  const totalRatings = items?.reduce(
    (sum: number, item: MenuItemType) => sum + item?.totalReview,
    0
  );

  const weightedRating = items?.reduce((sum: number, item: MenuItemType) => {
    const itemRating = item?.avgReview * item?.totalReview;
    return sum + itemRating;
  }, 0);

  const avgRating = totalRatings > 0 ? weightedRating / totalRatings : 0;

  return {
    avgReview: avgRating,
    totalReview: totalRatings,
  };
};

export const RatingInfo = ({ ratings }: RatingProps) => {
  const { avgReview, totalReview } = ratings;

  return (
    <View style={styles.ratingInfo}>
      <View
        style={[
          styles.ratingContainer,
          { backgroundColor: avgReview >= 4 ? "#00A877" : "#FF9800" },
        ]}
      >
        <Text style={styles.avgRating}>{avgReview.toFixed(1)}</Text>
        <Text style={styles.ratingStar}>★</Text>
      </View>
      <Text style={styles.ratingCount}>{formatToK(totalReview)} ratings</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  ratingInfo: {
    alignItems: "center",
  },
  ratingContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(8),
    paddingVertical: getResponsiveSize(4),
    borderRadius: 8,
    gap: getResponsiveSize(2),
  },
  avgRating: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
  },
  ratingStar: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
  },
  ratingCount: {
    marginTop: getResponsiveSize(4),
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
  },
});
